import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import {
    selectLocationData,
} from '../../appstate/cityToCity/selectors';
import DUCK_NAMESPACE from '../../types';

const ACTION_NAMESPACE = 'ACTIONS/COLLECT_EMAIL_ADDRESS';
const ENDPOINT_NAME = 'emailcollect';

const logger = Logger.getLogger('wanderu-app-seo:collectEmailAdress');

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(ACTION_NAMESPACE, DUCK_NAMESPACE);

function collectEmailAddress(pageId, data) {
    return async (dispatch, getState) => {
        const {
            emailAddress,
            firstName,
            promoEmailOptIn,
        } = data;
        const appState = getState();
        const c2cLocationData = selectLocationData(appState, pageId);
        const payload = {
            arrive_wcityid: c2cLocationData.arrival.wcityid,
            depart_wcityid: c2cLocationData.departure.wcityid,
            email: emailAddress,
            first_name: firstName,
            locale: selectLocale(appState),
            opt_in_checkbox: promoEmailOptIn,
            url: document.location.href,
        };
        let err = null;

        dispatch(actions.startWork());

        try {
            await WapiService.post(ENDPOINT_NAME, {
                body: payload,
            });
        } catch (ex) {
            err = ex.message;

            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('wapi post', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
        } finally {
            return dispatch(actions.endWork(undefined, err));
        }
    };
}

const collectEmailAddressAction = {
    collectEmailAddress,
    selectBusy(appState) {
        const opStatus = selectors.defaultSelector(appState);

        return opStatus && opStatus.working;
    },
    selectError: selectors.selectError,
};

export {
    collectEmailAddressAction,
};

export default {
    [ACTION_NAMESPACE]: reducer,
};
